// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fr-list-card {\n  margin-bottom: 24px;\n}\n.fr-list-card .fr-list-item {\n  display: flex;\n  align-items: flex-start;\n  position: relative;\n}\n.fr-list-card .fr-list-item-operate {\n  padding: 0 20px;\n  height: 32px;\n  gap: 0 !important;\n}\n.fr-list-card .fr-list-item-operate-fixed {\n  position: absolute;\n  right: 8px;\n}\n.fr-list-card .fr-list-add-btn {\n  padding: 0 8px;\n}\n", ""]);
// Exports
module.exports = exports;
